<template>
    <div class="row gutter-md">
        <div class="col-xs-12 col-sm-4" v-for="(certificate, index) in getTrainings" :key="index">
            <q-card class="bg-grey-1 cursor-pointer" @click.native="showCertificate(certificate)">
                <q-card-media>
                    <img :src="getCertificateImage(certificate)" v-if="certificate.group_training_images && certificate.group_training_images.length > 0">
                    <img :src="getPlaceholder" v-if="certificate.group_training_images && certificate.group_training_images.length == 0">
                </q-card-media>

                <q-card-main class="relative-position cursor-pointer text-center" style="min-height: 100px;">
                    <div class="line-card bg-primary absolute-top"></div>

                    <div class="row q-my-sm">
                        <div class="col-12 q-subheading text-weight-medium text-primary">
                            {{ certificate.group_training_title }}
                        </div>
                    </div>
                </q-card-main>

                <q-card-separator />

                <q-card-main>
                    <div class="row text-faded">
                        <div class="col-12">
                            {{ $t('date') }}: {{ format(certificate.result_date) }}
                        </div>
                        <div class="col-12">
                            {{ $t('percentage') }}: {{ certificate.percent.toFixed(2) }}%
                        </div>
                        <div class="col-12" v-if="showPoints">
                            {{ $t('earned_points') }}: {{ certificate.score }}
                        </div>
                    </div>
                </q-card-main>
            </q-card>
        </div>

        <div class="col-xs-12 col-sm-4" v-for="(certificate, index) in getWebcasts" :key="`w${index}`">
            <q-card class="bg-grey-1 cursor-pointer" @click.native="showCertificateWebcast(certificate)">
                <q-card-media>
                    <img :src="getCertificateImageWebcast(certificate)" v-if="certificate.webcast_images && certificate.webcast_images.length > 0">
                    <img :src="getPlaceholderWebcast" v-if="certificate.webcast_images && certificate.webcast_images.length == 0">
                </q-card-media>

                <q-card-main class="relative-position cursor-pointer text-center" style="min-height: 100px;">
                    <div class="line-card bg-primary absolute-top"></div>

                    <div class="row q-my-sm">
                        <div class="col-12 q-subheading text-weight-medium text-primary">
                            {{ certificate.webcast_title }}
                        </div>
                    </div>
                </q-card-main>

                <q-card-separator />

                <q-card-main>
                    <div class="row text-faded">
                        <div class="col-12">
                            {{ $t('date') }}: {{ format(certificate.result_date) }}
                        </div>
                        <div class="col-12">
                            {{ $t('percentage') }}: {{ certificate.percent.toFixed(2) }}%
                        </div>
                        <div class="col-12" v-if="showPoints">
                            {{ $t('earned_points') }}: {{ certificate.score }}
                        </div>
                    </div>
                </q-card-main>
            </q-card>
        </div>

        <div class="col-xs-12 col-sm-4" v-for="(certificate, index) in getLiveClass" :key="`lc${index}`">
            <q-card class="bg-grey-1 cursor-pointer" @click.native="showCertificateLiveClass(certificate)">
                <q-card-media>
                    <img :src="getCertificateImageLiveClass(certificate)" v-if="certificate.live_class_images && certificate.live_class_images.length > 0">
                    <img :src="getPlaceholder" v-if="certificate.live_class_images && certificate.live_class_images.length == 0">
                </q-card-media>

                <q-card-main class="relative-position cursor-pointer text-center" style="min-height: 100px;">
                    <div class="line-card bg-primary absolute-top"></div>

                    <div class="row q-my-sm">
                        <div class="col-12 q-subheading text-weight-medium text-primary">
                            {{ certificate.live_class_title }}
                        </div>
                    </div>
                </q-card-main>

                <q-card-separator />

                <q-card-main>
                    <div class="row text-faded">
                        <div class="col-12">
                            {{ $t('date') }}: {{ format(certificate.result_date) }}
                        </div>
                        <div class="col-12">
                            {{ $t('percentage') }}: {{ certificate.percent.toFixed(2) }}%
                        </div>
                        <div class="col-12" v-if="showPoints">
                            {{ $t('earned_points') }}: {{ certificate.score }}
                        </div>
                    </div>
                </q-card-main>
            </q-card>
        </div>

        <div class="col-xs-12 col-sm-4" v-for="(certificate, index) in getPresentials" :key="`p${index}`">
            <q-card class="bg-grey-1 cursor-pointer" @click.native="showCertificatePresential(certificate)">
                <q-card-media>
                    <img :src="getCertificateImagePresential(certificate)" v-if="certificate.presential_event_images.length > 0">
                    <img :src="getPlaceholderPresential" v-if="certificate.presential_event_images.length == 0">
                </q-card-media>

                <q-card-main class="relative-position cursor-pointer text-center" style="min-height: 100px;">
                    <div class="line-card bg-primary absolute-top"></div>

                    <div class="row q-my-sm">
                        <div class="col-12 q-subheading text-weight-medium text-primary">
                            {{ certificate.presential_event_title }}
                        </div>
                    </div>
                </q-card-main>

                <q-card-separator />

                <q-card-main>
                    <div class="row text-faded">
                        <div class="col-12">
                            {{ $t('date') }}: {{ format(certificate.result_date) }}
                        </div>
                        <div class="col-12" v-if="showPoints">
                            {{ $t('earned_points') }}: {{ certificate.presential_event_score }}
                        </div>
                        <div class="col-12"></div>
                    </div>
                </q-card-main>
            </q-card>
        </div>

        <div class="col-xs-12 col-sm-12 text-center" v-if="getPresentials.length === 0 && getTrainings.length === 0 && getLiveClass.length == 0 && getWebcasts.length === 0 && loaded">
            <q-card class="bg-grey-1">
                <q-card-main class="relative-position">
                    <div class="line-card bg-primary absolute-top"></div>

                    <div class="row q-my-sm">
                        <div class="col-12 q-subheading text-weight-medium">
                            {{ $t('no_certificates_found') }}
                        </div>
                    </div>
                </q-card-main>
            </q-card>
        </div>

        <q-inner-loading :visible="!loaded">
            <q-spinner-dots :size="60" color="secondary"></q-spinner-dots>
        </q-inner-loading>

        <certificate :show="show_certificate" :certificate="certificate" :data="certificate_data" @hideCertificate="hideCertificate" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Certificate from 'components/Certificate'
import { date } from 'quasar'
const { formatDate } = date

export default {
    components: {
        'certificate': Certificate
    },

    data() {
        return {
            certificates: [],
            certificate:[],
            selected_client_params: [],
            certificate_data: [],
            show_certificate: false,
            loaded: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id: 'common/id',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getPlaceholder() {
            if (!this.selected_client_params.group_training_placeholder) return ''
            else return this.selected_client_params.group_training_placeholder
        },

        getPlaceholderPresential() {
            if (!this.selected_client_params.presential_event_placeholder) return ''
            else return this.selected_client_params.presential_event_placeholder
        },

        getPlaceholderWebcast() {
            if (!this.selected_client_params.webcast_placeholder) return ''
            else return this.selected_client_params.webcast_placeholder
        },

        showPoints() {
            var obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if (obj) return obj.group_training_use_score
            else return false
        },

        getTrainings() {
            if (this.certificates.group_trainings) return this.certificates.group_trainings
            else return []
        },

        getLiveClass() {
            if (this.certificates.live_class) return this.certificates.live_class
            else return []
        },

        getPresentials() {
            if (this.certificates.presential_events) return this.certificates.presential_events
            else return []
        },

        getWebcasts() {
            if (this.certificates.webcasts) return this.certificates.webcasts
            else return []
        },
    },

    methods: {
        fetchData() {
            this.$q.loading.show()

            this.$axios.get(`/etraining_profile/my_profile/group_training_user_results/`, this.getHeader)
            .then(response => {
                this.certificates = response.data
                this.loaded = true
                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        showCertificate(certificate) {
            this.$q.loading.show()

            this.$axios.get(`/etraining_courses/group_training/${certificate.group_training_id}/get_group_training_user_result_certificate/`, this.getHeader)
            .then(response => {
                this.certificate = certificate
                this.certificate_data = response.data
                this.show_certificate = true
                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        showCertificatePresential(certificate) {
            this.$q.loading.show()

            let fd = new FormData()
            fd.append('user_id', this.id)

            this.$axios.get(`/etraining_presential/presential/${certificate.presential_event_id}/get_presential_event_user_result_certificate/`, fd, this.getHeader)
            .then(response => {
                this.certificate = certificate
                this.certificate_data = response.data
                this.show_certificate = true
                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        showCertificateLiveClass(certificate) {
            this.$q.loading.show()

            let fd = new FormData()
            fd.append('user_id', this.id)

            this.$axios.get(`/admin_live_classes/live_classes/${certificate.live_class_id}/certificate/`, fd, this.getHeader)
            .then(response => {
                this.certificate = certificate
                this.certificate_data = response.data
                this.show_certificate = true
                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        showCertificateWebcast(certificate) {
            this.$q.loading.show()

            this.$axios.get(`/etraining_webcasts/webcasts/${certificate.webcast_id}/get_webcast_user_result_certificate/`, this.getHeader)
            .then(response => {
                this.certificate = certificate
                this.certificate_data = response.data
                this.show_certificate = true
                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        hideCertificate() {
            this.show_certificate = false
            this.certificate_data = []
        },

        getCertificateImage(certificate) {
            let obj = certificate.group_training_images.find((obj) => { return obj.name === 'medium' })
            if (obj) return obj.image_url
            else return ''
        },

        getCertificateImagePresential(certificate) {
            let obj = certificate.presential_event_images.find((obj) => { return obj.name === 'medium' })
            if (obj) return obj.image_url
            else return ''
        },

        getCertificateImageLiveClass(certificate) {
            let obj = certificate.live_class_images.find((obj) => { return obj.name === 'medium' })
            if (obj) return obj.image
            else return ''
        },

        getCertificateImageWebcast(certificate) {
            let obj = certificate.webcast_images.find((obj) => { return obj.name === 'medium' })
            if (obj) return obj.image
            else return ''
        },

        format(date_raw) {
            return date.formatDate(date_raw, 'DD/MM/YYYY')
        }
    },

    created() {
        this.selected_client_params = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })

        this.fetchData()
    }
}
</script>

<style>

</style>
